var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('b-button',{attrs:{"ariant":"outline-info","block":""},on:{"click":function($event){return _vm.open()}}},[_vm._v(" New Media File ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }